import { useState, useEffect } from "react";
import useEventListener from "@use-it/event-listener";

// function getWindowDimensions() {
//   const { innerWidth: width, innerHeight: height } = window;
//   return {
//     width,
//     height,
//   };
// }

export default function useWindowDimensions() {
  const [dimension, setDimension] = useState({
    width: window.innerWidth,
    // height: window.innerHeight,
  });

  useEventListener(
    "resize",
    () => {
      setDimension({
        width: window.innerWidth,
        // height: window.innerHeight,
      });
    }
    // { passive: true }
  );

  return dimension;
}
